import { Attr, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class BulkWorkstationGroupAssignment extends ApplicationRecord {
  static jsonapiType = 'bulk_workstation_group_assignments';
  @Attr() workstationIds: string[];
  @Attr() groupIds: string[];
  @Attr({ persist: false }) createdCount: number;
}
